import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSortBy, useTable, usePagination } from "react-table";
import {
  add_icon,
  barcode_icon,
  filter_icon,
  search_icon,
  substract_icon,
  view_order_icon,
} from "../../assets";
import { Button, Modal, Select, Space } from "antd";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { GetStoreOrders } from "../../Api";
import { PosOrderLines } from "../../Api";
import { fetchStoreOrders } from "../../Redux/Action/orderAction";
import { format } from "date-fns";
import DraftOrdersTable from "./DraftOrdersTable";
import { useSelector, useDispatch } from "react-redux";
import { fetchPosOrderLines } from "../../Redux/Action/orderlinesAction";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import OrderReceiptPDF from "../Order/ordercomponents/OrderReceiptPDF";
import { toast } from "react-toastify";
import { addReturnProducts } from "../../Redux/Action/returnproductAction";
import { clearProducts } from "../../Redux/Action/productsAction";
import Table from "./TableOrder";
import { setCustomer } from "../../Redux/Action/getcustomerAction";
import { setForRefund } from "../../Redux/Action/refundAction";
import ProductList, { InvoiceButton, ResendButton } from "../Order/ProductList";
import Unpaid_Modal from "../Modal/Unpaid_Modal";
import PasswordModal from "../Modal/Password_Modal";
import { verifyPassword } from "../../API/API Functions/ProductRequest_API";
import i18next from "i18next";
import { detectWebDeviceType, isTablet } from "../../utils";

const SESSION_STORAGE_KEY = "products";

const LoadingSpinner = () => {
  return (
    <div
      style={{ zIndex: 100 }}
      className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 "
    >
      <div className="spinner ">
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
      </div>
    </div>
  );
};
// export function OrderSearchBar({ setSelectedButton }) {
//   const { t, i18n } = useTranslation();
//   const isRtl = i18n.dir() === "rtl";
//   const dispatch = useDispatch();
//   const ref = useRef(null);

//   const debounce = (func, delay) => {
//     let timer;
//     return function (...args) {
//       const context = this;
//       clearTimeout(timer);
//       timer = setTimeout(() => func.apply(context, args), delay);
//     };
//   };

//   const handleSearchChange = debounce((searchTerm) => {
//     const trimmedSearch = searchTerm.trim();
//     dispatch(fetchStoreOrders(0, trimmedSearch));
//     setSelectedButton("allOrders");
//   }, 500);

//   // const handleSearchChange = (searchTerm) => {
//   //   dispatch(fetchStoreOrders(0, searchTerm));
//   //   setSelectedButton("allOrders");
//   // };

//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.shiftKey && event.key === "x") {
//         ref.current.focus();
//       }
//     };

//     document.addEventListener("keydown", handleKeyDown);

//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [ref]);

//   return (
//     <div className={`relative flex ${isRtl ? "me-8" : "ms-8"} me-8 w-[100%]`}>
//       {isRtl ? (
//         <span className="absolute inset-y-0 right-0 flex items-center pr-3">
//           <img src={search_icon} alt="customers_search_icon" />
//         </span>
//       ) : (
//         <span className="absolute inset-y-0 left-0 flex items-center pl-3">
//           <img src={search_icon} alt="customers_search_icon" />
//         </span>
//       )}
//       <input
//         type="text"
//         ref={ref}
//         placeholder={t("Search receipt number, customer")}
//         className="border p-2 ps-10 rounded w-full focus:outline-none rounded-[6px]"
//         onChange={(e) => {
//           const searchTerm = e.target.value;
//           if (searchTerm.length >= 0) {
//             handleSearchChange(searchTerm);
//           }
//         }}
//       />
//     </div>
//   );
// }

export function OrderSearchBar({
  setSelectedButton,
  pagination,
  setSearchValue,
  setType,
}) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchType, setSearchType] = useState(null); // "customer", "receipt", "product"
  const [showSuggestions, setShowSuggestions] = useState(false);

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const triggerSearch = debounce((term, type) => {
    const trimTerm = term.trim();
    if (trimTerm && type) {
      if (type === "customName") {
        dispatch(fetchStoreOrders(pagination, "", "", trimTerm, null, type)); // pass as product_name
      } else if (type === "shortCode") {
        dispatch(fetchStoreOrders(pagination, "", "", trimTerm, null, type)); // pass as order_ref
      } else if (type === "product") {
        dispatch(fetchStoreOrders(pagination, "", "", trimTerm, null, type)); // pass as product_name
      } else {
        dispatch(fetchStoreOrders(pagination, trimTerm)); // pass as order_ref
      }
      setSelectedButton("allOrders");
    }
  }, 500);

  const suggestions = [
    { type: "customer", label: t("Search by Customer Name / Phone") },
    { type: "receipt", label: t("Search by Receipt No.") },
    { type: "product", label: t("Search by Product") },
    { type: "shortCode", label: t("Search by Short Code") },
    { type: "customName", label: t("Search by Custom Name") },
  ];

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setSearchValue(value);
    setShowSuggestions(!searchType);

    if (searchType) {
      triggerSearch(value, searchType);
    }
  };

  const handleSelectType = (type) => {
    setSearchType(type);
    setType(type);
    setShowSuggestions(false);
    triggerSearch(searchTerm, type);
  };

  const clearFilter = () => {
    setSearchTerm("");
    setSearchValue("");

    setSearchType(null);
    setType(null);
    setShowSuggestions(false);
    dispatch(fetchStoreOrders(pagination, ""));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.shiftKey && event.key === "x") {
        inputRef.current.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className={`relative w-full ${isRtl ? "me-8" : "ms-8"} me-8`}>
      {/* Tag with clear filter */}
      {searchType && (
        <div
          className={`${
            isRtl ? "right-0" : "left-0"
          } absolute -top-9 bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm"`}
        >
          <span className="capitalize">
            {isRtl ? (
              <>
                {/* <strong>{searchTerm}</strong>:  */}
                {t(searchType)}
              </>
            ) : (
              <>
                {t(searchType)}
                {/* : <strong>{searchTerm}</strong> */}
              </>
            )}
          </span>
          <button onClick={clearFilter} className="ms-1 text-xs">
            ❌
          </button>
        </div>
      )}

      {/* Input box */}
      <div className="relative me-2">
        {isRtl ? (
          <span className="absolute inset-y-0 right-0 flex items-center pr-3">
            <img src={search_icon} alt="search" />
          </span>
        ) : (
          <span className="absolute inset-y-0 left-0 flex items-center pl-3">
            <img src={search_icon} alt="search" />
          </span>
        )}

        <input
          type="text"
          ref={inputRef}
          placeholder={t("Search receipt number, customer")}
          className="border p-2 ps-10 rounded w-full focus:outline-none rounded-[6px]"
          value={searchTerm}
          onChange={handleInputChange}
          onFocus={() => !searchType && setShowSuggestions(true)}
        />
      </div>

      {/* Suggestion Dropdown */}
      {showSuggestions && !searchType && searchTerm.length > 0 && (
        <ul className="absolute bg-white border mt-1 rounded shadow z-10 w-full">
          {suggestions.map(({ type, label }) => (
            <li
              key={type}
              className="px-4 py-2 hover:bg-gray-100 border-b-2 text-blue-900 italic cursor-pointer text-sm"
              onClick={() => handleSelectType(type)}
            >
              {label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function AllOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "ms-0" : "ms-6"
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Orders")}</div>
    </div>
  );
}

function RefundedOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "" : ""
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Refunded Orders")}</div>
    </div>
  );
}

function CancelledOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "" : ""
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Cancelled Orders")}</div>
    </div>
  );
}


function UnpaidOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "" : ""
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Unpaid Orders")}</div>
    </div>
  );
}

function OrderFromButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "" : ""
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Order From")}</div>
    </div>
  );
}

function ReturnOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "ms-1" : "ms-8"
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    showButtons == true
      ? " border-[#9dd8ff] bg-[#1b4597] text-white "
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("All Orders")}</div>
    </div>
  );
}

function PaidOrderButton({ onClick }) {
  return (
    <div
      className="flex justify-center px-3 py-2 font-medium  hover:font-semibold text-zinc-800 bg-white  border border-solid border-stone-300 whitespace-nowrap rounded-lg"
      onClick={onClick}
    >
      <div className="mt-0.5 ml-0.5">Paid</div>
    </div>
  );
}

function RefundOrderButton({ onClick }) {
  const { t, i18n } = useTranslation();

  return (
    <div
      className="flex justify-center w-[20vh] h-[10vh] items-center font-semibold  hover:font-semibold text-white bg-[#F42020] border border-solid border-stone-300 whitespace-nowrap rounded-lg cursor-pointer"
      onClick={onClick}
    >
      <div className=" justify-center items-center">{t("Return")}</div>
    </div>
  );
}

function DraftOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();

  const buttonClasses = `flex cursor-pointer justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled
      ? // ? "border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  } ${showButtons == true ? "ms-48" : "ms-0"}`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Draft Orders")}</div>
    </div>
  );
}

function OrderSkeleton() {
  return (
    <Stack spacing={1} marginTop={5}>
      {/* <Skeleton variant="text" sx={{ fontSize: '1rem' }} /> */}
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      {/* <Skeleton variant="rectangular" width={210} height={60} /> */}
      {/* <Skeleton variant="rounded" width={385} height={60} />
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
      <Skeleton variant="rectangular" width={385} height={60} /> */}
    </Stack>
  );
}

function Order_Table() {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();
  const { orders = [] } = useSelector((state) => state.orders);
  const { orderLines = [] } = useSelector((state) => state.orderlinesReducer);
  const [filteredData, setFilteredData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [pagination, setPagination] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showDraftOrdersTable, setShowDraftOrdersTable] = useState(false);
  const [showOrderTable, setShowOrderTable] = useState(true);
  const { user } = useSelector((state) => state?.login);
  const draftOrders = useSelector((state) => state.draftOrders.draftOrders);
  const [selectedOrderIndex, setSelectedOrderIndex] = useState(-1);
  const [showResendButton, setShowResendButton] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [refundItems, setRefundItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false); // Define loading state
  const [showRefundedOrders, setShowRefundedOrders] = useState(false);
  const [selectedButton, setSelectedButton] = useState("allOrders"); // Track selected button
  const [selectedProductIndex, setSelectedProductIndex] = useState(-1);
  const userData = useSelector((state) => state?.login?.user?.result);
  const [showButtons, setShowButtons] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [searchType, setSearchType] = useState("");
  const [isUnpaidModalVisible, setIsUnpaidModalVisible] = useState(false);
  const [showConfirmCancelModal, setShowConfirmCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelReasonType, setCancelReasonType] = useState("");
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [orderFromOptions, setOrderFromOptions] = useState([]);
  const location = useLocation();
  const forRefund = useSelector((state) => state.refundReducer.forRefund);

  const showOrders = useSelector(
    (state) => state?.permissionReducer?.permissions?.show_orders,
  );

  const [isProductSelectionActive, setIsProductSelectionActive] =
    useState(false);
  const closeSession = useSelector(
    (state) => state?.sessionReducer?.closeSession,
  );
  const [openPassword, setOpenPassword] = useState(false);
  // const requiredPass = useSelector(
  //   (state) => state?.login?.user?.result?.is_password_restrict
  // );
  const requiredPass = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_password_restrict,
  );
  const closePasswordModal = () => setOpenPassword(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showCancelledOrders, setShowCancelledOrders] = useState(false);
  const [selectedOrderFrom, setSelectedOrderFrom] = useState(null);
  const isETAenabled = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_eta_enabled,
  );
  // Replace with:
  useEffect(() => {
    if (location.pathname === "/orders" && location.search === "") {
      setShowButtons(false);
      dispatch(setForRefund(false));
    } else if (
      location.pathname === "/orders" &&
      location.search.includes("refundorder")
    ) {
      setShowButtons(true);
    } else if (
      location.pathname === "/orders" &&
      location.search.includes("tab=draft")
    ) {
      setShowButtons(false);
      dispatch(setForRefund(false));
      // Auto-open draft orders
      setShowDraftOrdersTable(true);
      setShowOrderTable(false);
      setSelectedButton("draftOrders");
    }
  }, [location]);
  // useEffect(() => {
  //   if (selectedButton === "allOrders") {
  //     dispatch(fetchStoreOrders(pagination, null, ""));
  //   } else if (selectedButton === "refundedOrders") {
  //     dispatch(fetchStoreOrders(pagination, null, "refunded"));
  //   } else if (selectedButton === "unpaidOrders") {
  //     dispatch(fetchStoreOrders(pagination, null, "unpaid"));
  //   }
  // }, [selectedButton, pagination, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingData(true);
      getOrderFrom();
      try {
        await dispatch(
          fetchStoreOrders(
            pagination,
            "",
            "",
            searchValue,
            undefined,
            searchType,
          ),
        );
        setLoading(false);
        setIsProductSelectionActive(true);
        setSelectedProductIndex(0);
        setSelectedOrderIndex(null);
        setDrawerOpen(false);
      } catch (error) {
        console.error("Error fetching orders:", error);
        setLoading(false);
      } finally {
        setIsLoadingData(false);
      }
    };

    fetchData();
  }, [dispatch, pagination]);

  useEffect(() => {
    if (showOrders) {
      if (orders) {
        setFilteredData(orders);
        if (setSelectedButton === "refunded") {
          setFilteredData(orders);
        }
        if (setSelectedButton === "unpaidOrders") {
          setFilteredData(orders);
        }
        if (setSelectedButton === "orderFrom") {
          setFilteredData(orders);
        }
      }
    }
  }, [orders, showOrders]);

  useEffect(() => {
    if (!showOrders) {
      if (
        orders &&
        orders?.length > 0 &&
        searchValue?.length > 2 &&
        searchType != ""
      ) {
        setSearchData(orders);
      } else {
        setSearchData([]);
      }
    }
  }, [orders, showOrders, searchType]);

  const lang = i18n.language;

  const handleRowClick = async (order) => {
    setLoading(true);
    // console.log("HCLALA ");

    setSelectAll(false);
    setRefundItems([]);
    setSelectedProducts({});
    try {
      setSelectedOrder(order);
      setDrawerOpen(true);
      await dispatch(fetchPosOrderLines(order.id, lang));
      setSelectedOrder(order);
      // console.log("HCLALA 2 ");

      navigate(`/orders?orderid=${order.id}`, {
        preventScrollReset: true,
      });
      window.history.pushState({}, "", `/orders?orderid=${order.id}`);
      setShowResendButton(!!order.customer_phone);
    } catch (error) {
      console.error("Error fetching order lines:", error);
    } finally {
      // console.log("HCLALA 3");
      setLoading(false);
    }
  };

  const handleDraftOrderClick = (draftOrder) => {
    setPagination(0);
    setSelectedOrder(draftOrder);
    setDrawerOpen(false);
    setSelectAll(false);
  };

  // console.log("cdsdcdscdsc", orderFromOptions);

  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: t("Session"),
        accessor: "session",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Receipt No."),
        accessor: "receipt_no",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Order Date"),
        accessor: "date_order",
        Cell: ({ value }) => (
          <div className="flex-auto max-md:max-w-full">{value}</div>
        ),
        sortType: "alphanumeric",
      },
      {
        Header: t("Salesman"),
        accessor: "salesman",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value ? value : "--"}</div>
        ),
      },
      {
        Header: t("Customer"),
        accessor: "customer_name",
        Cell: ({ row }) => (
          <div className="my-auto text-ellipsis">
            {row.original.customer_name
              ? row.original.customer_name
              : row.original.customer_phone
                ? row.original.customer_phone
                : "--"}
          </div>
        ),
      },

      {
        Header: t("No. Of Items"),
        accessor: "items",
        Cell: ({ value }) => (
          <div className="flex-auto max-md:max-w-full">{value}</div>
        ),
        sortType: "alphanumeric",
      },
      {
        Header: t("Total"),
        accessor: "order_value",
        Cell: ({ value }) => (
          <div className="flex-auto max-md:max-w-full">
            {i18n.language === "ar" && value < 0 ? (
              <span> {Math.abs(value).toFixed(2)}- EGP</span>
            ) : (
              <span>{Number(value).toFixed(2)} EGP</span>
            )}
          </div>
        ),
      },

      ...(orderFromOptions?.length > 0
        ? [
            {
              Header: t("Order From"),
              accessor: "order_from",
              Cell: ({ value }) => (
                <div className="my-auto text-ellipsis">
                  {(value === "self_delivery"
                    ? t("Self Delivery")
                    : t(value)) || "--"}
                </div>
              ),
            },
          ]
        : []),

      {
        Header: t("Payment Type"),
        accessor: "payment",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value ? t(value) : "--"}</div>
        ),
      },
    ];

    if (!drawerOpen) {
      baseColumns.push({
        Header: t("Status"),
        accessor: "state",
        Cell: ({ row }) => {
          const { state } = row.original;

          const handleStatusClick = (e, order) => {
            e.stopPropagation();
            setSelectedOrderDetails(order);
            setIsUnpaidModalVisible(true);
          };

          if (state === "Unpaid") {
            return (
              <button
                onClick={(e) => handleStatusClick(e, row.original)} // Pass the row data
                className={`px-2 py-0 rounded-lg bg-amber-500 text-white font-semibold`}
              >
                {t("Unpaid")}
              </button>
            );
          }
          if (state === "Cancelled") {
            return (
              <button
                // onClick={(e) => handleStatusClick(e, row.original)} // Pass the row data
                className={`px-2 py-0 rounded-lg bg-[#F42020] text-white font-semibold`}
              >
                {t("Cancelled")}
              </button>
            );
          }

          if (state === "Paid") {
            return (
              <button
                // onClick={handleStatusClick}

                className={`px-2 py-0 rounded-lg ${
                  state === "Paid"
                    ? "bg-[#7EC242] text-white font-semibold"
                    : "bg-[#F42020] text-white font-semibold"
                }`}
              >
                {state === "Paid" ? t("Paid") : t("Unpaid")}
              </button>
            );
          } else {
            return null;
          }
        },
      });
    }
    if (!drawerOpen) {
      baseColumns.push({
        Header: " ",
        Cell: ({ row }) => (
          <button
            onClick={() => handleRowClick(row.original)}
            style={{ backgroundColor: "transparent", border: "none" }}
          >
            <img
              src={view_order_icon}
              alt="view_order_icon"
              className={`w-8 h-4 transition-transform transform ${
                i18n.language === "ar" ? "scale-x-[-1]" : ""
              }`}
            />
          </button>
        ),
      });
    }

    return baseColumns;
  }, [drawerOpen, user?.currency, orderFromOptions]);

  const navigate = useNavigate();

  const handleDraftClick = () => {
    if (showOrders) {
      setPagination(0);
      setDrawerOpen(false);
      setShowDropdown(false);
      setShowDraftOrdersTable(true);
      setShowOrderTable(false);
      setSelectAll(false);
      setSelectedOrderFrom(null);
      setSelectedButton("draftOrders");
    } else {
      setPagination(0);
      setDrawerOpen(false);
      setShowDraftOrdersTable(!showDraftOrdersTable);
      setShowOrderTable(showDraftOrdersTable ? true : false);
      setSelectAll(false);
      setSelectedOrderFrom(null);
      setSelectedButton(showDraftOrdersTable ? "allOrders" : "draftOrders");
    }
  };

  const handleAllOrderClick = async () => {
    setPagination(0);
    setLoading(true);
    setShowDropdown(false);
    setShowDraftOrdersTable(false);
    setShowOrderTable(true);
    setSelectedOrderFrom(null);
    setShowCancelledOrders(false);
    setShowRefundedOrders(false);
    setSelectedButton("allOrders");
    await dispatch(fetchStoreOrders(0, null, ""));
    setLoading(false);
  };

  const handleRefundedOrderClick = async () => {
    setPagination(0);
    setLoading(true);
    setShowDropdown(false);
    setShowCancelledOrders(false);
    setShowRefundedOrders(true);
    setDrawerOpen(false);
    setShowDraftOrdersTable(false);
    setShowOrderTable(true);
    setSelectedOrderFrom(null);
    setSelectedButton("refundedOrders");
    await dispatch(fetchStoreOrders(0, null, "refunded"));
    setLoading(false);
  };

  const handleCancelledOrderClick= async () => {
    setPagination(0);
    setLoading(true);
    setShowCancelledOrders(true);
    setShowDropdown(false);
    setShowRefundedOrders(false);
    setDrawerOpen(false);
    setShowDraftOrdersTable(false);
    setShowOrderTable(true);
    setSelectedOrderFrom(null);
    setSelectedButton("cancel");
    await dispatch(fetchStoreOrders(0, null, "cancel"));
    setLoading(false);
  };

  const handleUnpaidOrderClick = async () => {
    setPagination(0);
    setLoading(true);
    setShowDropdown(false);
    setShowCancelledOrders(false);
    setShowRefundedOrders(false);
    setDrawerOpen(false);
    setShowDraftOrdersTable(false);
    setShowOrderTable(true);
    setSelectedButton("unpaidOrders");
    setSelectedOrderFrom(null);
    await dispatch(fetchStoreOrders(0, null, "unpaid"));
    setLoading(false);
  };

  const handleOrderFromClick = async () => {
    setPagination(0);
    // Toggle dropdown visibility
    // if (!showDropdown && orderFromOptions.length === 0) {
    // setLoadingOrderFrom(true);
    // const response = await dispatch(fetchOrderFromOptions()); // <- Your API call here
    // setOrderFromOptions(response.payload || []);
    // setLoadingOrderFrom(false);
    // }
    setShowDropdown(!showDropdown);
  };

  const handleOrderFromSelect = async (method) => {
    // Deselect if same
    if (selectedOrderFrom?.id === method.id) {
      setShowDropdown(false);
      return;
      // setSelectedOrderFrom(null);
      // setSelectedButton("orderFrom")
      // await dispatch(fetchStoreOrders(0, null, null)); // no filter
    } else {
      setPagination(0);
      setLoading(true);
      setShowRefundedOrders(false);
    setShowCancelledOrders(false);
      setShowDraftOrdersTable(false);
      setShowOrderTable(true);
      setSelectedOrderFrom(method);
      await dispatch(fetchStoreOrders(0, null, null, "", method.id)); // send selected option
      setLoading(false);
    }
  };

  const getOrderFrom = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.ORDER_FROM, {
        user_id: userData?.user_id,
        lang: i18next.language === "ar" ? "ar" : "en_US",
      });

      const posOrderFrom = response?.data?.result?.[0]?.pos_order_from;
      setOrderFromOptions(posOrderFrom);
    } catch (err) {
      console.error(err);
      // setErrorMessage("Failed to fetch order from options.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get("orderid");
    if (orderId) {
      const order = orders.find(
        (order) => order.order_id === parseInt(orderId),
      );
      if (order) {
        handleRowClick(order);
      }
    }
  }, [orders]);

  const handleResetClick = async () => {
    const params = new URLSearchParams(window.location.search);
    const orderid = params.get("orderid");
    const order_id = Number(orderid);

    try {
      const response = await axiosInstance.post(URLS.SEND_CUSTOMER_SMS, {
        order_id,
      });

      if (
        response.data &&
        response.data.result &&
        response.data.result.status_code === 200
      ) {
        toast.success(t("Message sent Successfully"));
      } else {
        toast.error(t(response.data.result.status));
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("An error occurred while sending the message");
    }
  };

  const handleInvoiceClick = async () => {
    const params = new URLSearchParams(window.location.search);
    const orderid = params.get("orderid");
    const order_id = Number(orderid);
    const response = await axiosInstance.post(URLS.RECEIPT_ORDER_DETAILS, {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      order_id,
    });
    const isElectron = window.electronAPI?.isElectron;
    const isReactNativeWebView =
      window.ReactNativeWebView &&
      typeof window.ReactNativeWebView.postMessage === "function";

    if (isElectron && window.electronAPI?.sendReceiptData && response) {
      handlePrint(response?.data?.result, userData);
      return;
    }
    if (isReactNativeWebView && response) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "PRINT_RECEIPT",
          payload: response?.data?.result,
        }),
      );
      return;
    }
    if (response) {
      handlePrintInvoice(response?.data?.result);
    }
  };

  const handlePrint = async (data, user) => {
    const html = await OrderReceiptPDF(
      data,
      t,
      i18n.language,
      user,
      "",
      isETAenabled,
    );
    if (window.electronAPI?.sendReceiptData) {
      window.electronAPI.sendReceiptData(html);
    } else {
      console.warn("electronAPI.sendReceiptData is not available");
    }
  };

  let order_page = "order_page";

  const handlePrintInvoice = (data) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(
      OrderReceiptPDF(
        data,
        t,
        i18n.language,
        userData,
        order_page,
        isETAenabled,
      ),
    );
    doc.close();

    iframe.contentWindow.focus();

    setTimeout(() => {
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 1000);
  };
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    setSelectedProducts((prev) => {
      const newSelectedProducts = {};
      const updatedRefundItems = [];

      if (isChecked) {
        orderLines?.forEach((product, index) => {
          const packId = product.pack_id || product.package_id || "";
          const uniqueKey = `${product.product_id}_${packId}_${index}`; // use index if absolutely needed
          const add_qty = packId ? product.qty : product.available_refund_qty;

          if (product.available_refund_qty > 0) {
            newSelectedProducts[uniqueKey] = true;

            updatedRefundItems.push({
              ...product,
              id:
                product.hamper_id && product?.hamper_id != null
                  ? product.hamper_id
                  : product.product_id || product.id,
              hamper_id: product.hamper_id,
              quantity:
                product.uom == "KG" && product.is_selling_gram
                  ? add_qty * 1000
                  : add_qty,
              sale_price:
                product.price +
                (product?.tax_amount ? product?.tax_amount / product.qty : 0) -
                product.discount_amount / product.qty -
                product.discounted_value,
              pack_id: packId,
              // tax_amount: (product.tax_amount/product.qty) * add_qty,
              discount_amount:
                (product.discount_amount / product.qty) * add_qty +
                product.discounted_value,
              payment_method_id: selectedOrder?.payment_method_id,
              bank_id: selectedOrder?.bank_id,
            });
          }
        });
      } else {
        Object.keys(prev).forEach((productKey) => {
          delete newSelectedProducts[productKey];
        });
      }
      console.log("updatedRefundItems===>", updatedRefundItems);

      setRefundItems(updatedRefundItems);
      return newSelectedProducts;
    });
  };

  const handleProductCheckboxChange = (productId) => (e) => {
    const isChecked = e.target.checked;
    setSelectedProducts((prev) => {
      const newSelectedProducts = { ...prev };
      if (isChecked) {
        newSelectedProducts[productId] = true;
      } else {
        delete newSelectedProducts[productId];
      }
      if (Object.keys(newSelectedProducts).length === 0) {
        setSelectAll(false);
      } else if (
        Object.keys(newSelectedProducts).length === orderLines.length
      ) {
        setSelectAll(true);
      } else if (
        Object.keys(newSelectedProducts).length !== orderLines.length
      ) {
        setSelectAll(false);
      }
      return newSelectedProducts;
    });
  };

  useEffect(() => {
    if (Object.keys(selectedProducts).length === orderLines.length) {
      setSelectAll(true);
    } else if (Object.keys(selectedProducts).length === 0) {
      setSelectAll(false);
    } else if (Object.keys(selectedProducts).length !== orderLines.length) {
      setSelectAll(false);
    }
  }, [selectedProducts]);

  useEffect(() => {
    if (selectAll) {
      const newSelectedProducts = {};
      orderLines.forEach((product) => {
        if (product.available_refund_qty > 0) {
          newSelectedProducts[product.product_id] = true;
        }
      });
      setSelectedProducts(newSelectedProducts);
    } else {
    }
  }, [selectAll]);

  useEffect(() => {
    const availableProducts = orderLines.filter(
      (product) => product.available_refund_qty > 0,
    );

    if (availableProducts.length === 0) {
      setSelectAll(false);
    } else {
      const allSelected = availableProducts.every(
        (product) => selectedProducts[product.product_id],
      );
      setSelectAll(allSelected);
    }
  }, [selectedProducts, orderLines]);

  const updateRefundItems = (product, quantity, isSelected) => {
    const updatedRefundItems = [...refundItems];

    const productKey = `${product.id}_${product.pack_id || ""}`;

    // Find using composite key
    const existingProductIndex = updatedRefundItems.findIndex((item) => {
      const itemKey = `${item.id}_${item.pack_id || ""}`;
      return itemKey === productKey;
    });

    if (existingProductIndex !== -1) {
      updatedRefundItems.splice(existingProductIndex, 1);
    }

    if (isSelected) {
      updatedRefundItems.push({
        ...product,
        quantity:
          product.uom == "KG" && product.is_selling_gram
            ? quantity * 1000
            : quantity,
        hamper_id: product.hamper_id,
        id:
          product.hamper_id && product?.hamper_id != null
            ? product.hamper_id
            : product.product_id || product.id,
        sale_price:
          product.rate +
          (product?.tax_amount ? product?.tax_amount / product?.quantity : 0) -
          product.discount_amount -
          product.discounted_value,
        discount_amount:
          product.discount_amount * quantity + product.discounted_value,
        pack_id: product.pack_id, // map for consistency
      });
    }
    setRefundItems(updatedRefundItems);
  };

  useEffect(() => {
    const availableRefundProducts = orderLines.filter(
      (product) => product.available_refund_qty > 0,
    );
    if (refundItems.length != availableRefundProducts.length) {
      setSelectAll(false);
    }
    if (refundItems.length === availableRefundProducts.length) {
      setSelectAll(true);
    }
    if (refundItems.length === 0) {
      setSelectAll(false);
    }
  }, [refundItems]);

  const handlePasswordConfirm = async (enteredPassword) => {
    setLoading(true);
    const userId = userData?.user_id;
    const action = "Return Order";

    try {
      const verificationResult = await verifyPassword(
        userId,
        enteredPassword,
        action,
      );

      if (
        verificationResult &&
        verificationResult?.result?.status_code === 200
      ) {
        handleReturnClick();
        closePasswordModal();
        setLoading(false);
      } else if (verificationResult?.result?.status_code === 400) {
        toast.error(t("Incorrect password"));
        setLoading(false);
        return;
      }
    } catch (error) {
      console.error("Error verifying password:", error);
    }
  };

  const ReturnButtonClick = () => {
    if (refundItems.length === 0) {
      toast.error(t("Please select a product for return."));
      return;
    }

    if (requiredPass === true) {
      setOpenPassword(true);
    } else {
      handleReturnClick();
    }
  };

  const handleReturnClick = async () => {
    setLoading(true);

    if (selectedOrder) {
      const order_id = selectedOrder.id;

      const uniqueRefundItems = [
        ...new Map(
          refundItems.map((item) => [`${item.id}_${item.pack_id || ""}`, item]),
        ).values(),
      ];

      const filteredRefundItems = uniqueRefundItems.filter(
        (item) => item.quantity > 0,
      );

      // ✅ Map pack_id to pack_id
      const productsWithOrderId = filteredRefundItems.map((product) => ({
        ...product,
        order_id,
        pack_id: product.pack_id, // ✅ Add this line
      }));
      console.log("productsWithOrderId", productsWithOrderId);

      dispatch(clearProducts());
      dispatch(setCustomer(selectedOrder.customer_phone));
      dispatch(addReturnProducts(productsWithOrderId));
      navigate(`/session?refundorder=${selectedOrder.id}`);
    }
  };

  const areAllProductsRefundedOrNegative = () => {
    return orderLines.every((product) => {
      const productValue = product.available_refund_qty;
      return productValue <= 0;
    });
  };

  useEffect(() => {
    if (closeSession) {
      // console.log("CHALLL GYAAAAA");
      setIsProductSelectionActive(true);
      setSelectedProductIndex(0);
      setSelectedOrderIndex(null);
      setDrawerOpen(false);
    }
  }, [closeSession]);

  const handleKeyDown = useCallback(
    (e) => {
   
      const tag = document.activeElement?.tagName?.toLowerCase();
    if (tag === "input" || tag === "textarea") return; // ✅ MUST be first

    if (showConfirmCancelModal) return;
    if (closeSession) return;

      if (closeSession) {
        return;
      }
      const key = e.key.toLowerCase();
      const normalizedKey =
        {
          "~": "z",
          "ِ": "a",
          "؛": "p",
          "ٌ": "r",
          ء: "x",
          "َ": "q",
          "ُ": "e",
          escape: "escape",
        }[key] || key;

      if (e.shiftKey && normalizedKey === "z") {
        handleDraftClick();
      } else if (e.shiftKey && normalizedKey === "a") {
        handleAllOrderClick();
      } else if (e.shiftKey && normalizedKey === "e") {
        setIsProductSelectionActive(true);
        setSelectedProductIndex(0);
        setSelectedOrderIndex(null);
        setDrawerOpen(false);
      } else if (normalizedKey === "escape") {
        e.preventDefault();
        setDrawerOpen(false);
      } else if (e.shiftKey && normalizedKey === "q") {
        handleRefundedOrderClick();
      } else if (
        normalizedKey === (i18n.language === "ar" ? "arrowleft" : "arrowright")
      ) {
        setIsProductSelectionActive(true);
        setSelectedProductIndex(0);
        setSelectedOrderIndex(null);
      } else if (
        normalizedKey === (i18n.language === "ar" ? "arrowright" : "arrowleft")
      ) {
        setIsProductSelectionActive(false);
        setSelectedOrderIndex((prevIndex) => Math.max(prevIndex - 1, 0));
        setSelectedProductIndex(null);
      }
      if (isProductSelectionActive) {
        if (normalizedKey === "arrowup") {
          e.preventDefault();
          if (selectedProductIndex > 0) {
            setSelectedProductIndex((prevIndex) => prevIndex - 1);
          }
        } else if (normalizedKey === "arrowdown") {
          e.preventDefault();
          if (selectedProductIndex < orderLines.length - 1) {
            setSelectedProductIndex((prevIndex) => prevIndex + 1);
          }
        }
      } else {
        if (showOrderTable && filteredData.length > 0) {
          e.preventDefault();
          if (normalizedKey === "arrowup") {
            setSelectedOrderIndex((prevIndex) => Math.max(prevIndex - 1, 0));
          } else if (normalizedKey === "arrowdown") {
            e.preventDefault();
            setSelectedOrderIndex((prevIndex) =>
              Math.min(prevIndex + 1, filteredData.length - 1),
            );
          } else if (normalizedKey === "enter" && selectedOrderIndex >= 0) {
            const order = filteredData[selectedOrderIndex];
            handleRowClick(order);
          } else if (e.shiftKey && normalizedKey === "a") {
            e.preventDefault();
            handleSelectAll({ target: { checked: !selectAll } });
          } else if (drawerOpen) {
            if (e.shiftKey && normalizedKey === "p") {
              handleInvoiceClick();
            } else if (
              e.shiftKey &&
              normalizedKey === "r" &&
              selectedOrder &&
              selectedOrder.customer_phone &&
              showResendButton
            ) {
              e.preventDefault();
              handleResetClick();
            }
          }
        }
      }
      if (drawerOpen) {
        if (normalizedKey === "enter" && isProductSelectionActive === true) {
          e.preventDefault();
          if (selectedOrder.state === "Unpaid") {
            setIsUnpaidModalVisible(true);
            setSelectedOrderDetails(selectedOrder);
            return; // Do nothing if the order is done
          }
          // handleReturnClick();
          ReturnButtonClick();
        } else if (e.shiftKey && normalizedKey === "l") {
          setIsProductSelectionActive(false);
        }
      }
    },
    [
      showConfirmCancelModal,
      showOrderTable,
      filteredData,
      selectedOrderIndex,
      selectedOrder,
      showResendButton,
      handleRowClick,
      handleInvoiceClick,
      handleResetClick,
      handleDraftClick,
      handleAllOrderClick,
      handleSelectAll,
      selectAll,
      orderLines,
      isProductSelectionActive,
    ],
  );

  const [eKeyPressed, setEKeyPressed] = useState(
    localStorage.getItem("eKeyPressed"),
  );

  const HandleCancelOrder = async (order) => {
    try {
      setLoading(true);

      // console.log("handleRemoveProducts", selectedGroupProducts);

      const payload = {
        order_id: order?.id,
        reason: cancelReasonType === "Other" ? cancelReason : cancelReasonType,
      };

      // console.log("API Payload:", payload);

      const res = await axiosInstance.post(URLS.CANCEL_DELIVERY_ORDER, payload);
      const result = res?.data?.result;

      if (result?.status_code === 200) {
        toast.success(t("Order Cancelled"));
        handleAllOrderClick();
setDrawerOpen(false);
        setShowConfirmCancelModal(false);
        setCancelReason('');
      } else {
        toast.error(result?.status);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleStorageChange = () => {
      setEKeyPressed(localStorage.getItem("eKeyPressed"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (eKeyPressed !== "true") {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown, eKeyPressed]);

  // const handlePaymentSuccess = () => {

  //   handleAllOrderClick();

  // };

  const handlePaymentSuccess = () => {
    // Call the function to handle all orders
    handleAllOrderClick();
    setDrawerOpen(false);
    //  handleRowClick();

    // const params = new URLSearchParams(window.location.search);
    // const orderId = params.get("orderid");
    // console.log("ORDERID",orderId);

    // if (orderId) {
    //   const order = orders.find(
    //     (order) => order.order_id === orderId

    //   );
    //   console.log("order",order);

    //   setSelectedOrder(order);
    //   dispatch(fetchPosOrderLines(orderId, lang));
    // Now, check if the orderId is still available
    // }
  };
  const deviceType = detectWebDeviceType();

 const cancelReasonOptions = [
  { label: t("Customer not available at delivery location"), value: "Customer not available at delivery location" },
  { label: t("Customer requested cancellation"), value: "Customer requested cancellation" },
  { label: t("Delivery issue"), value: "Delivery issue" },
  { label: t("Other"), value: "Other" },
];


  return (
    <>
      {loading && <LoadingSpinner />}
      {openPassword === true && (
        <PasswordModal
          onCancel={closePasswordModal}
          onConfirm={handlePasswordConfirm}
          // onCancel={setOpenPassword(false)}
        />
      )}

<Modal
  open={showConfirmCancelModal}
  onCancel={() => { 
    setShowConfirmCancelModal(false); 
    setCancelReason(""); 
    setCancelReasonType("");
  }}
  footer={null}
  centered
  closable={false}
  width={700}
>
  <div className="flex flex-col items-center p-8 pb-6">

    <h3 className="text-2xl font-semibold text-gray-800 text-center mb-6">
      {t("Are you sure you want to cancel this order?")}
    </h3>

    <div className="w-full mb-4">
      <label className="block text-lg text-gray-800 mb-2">
        {t("Reason for cancellation")}
      </label>
      <Select
        value={cancelReasonType || undefined}
        onChange={(val) => {
          setCancelReasonType(val);
          if (val !== "Other") {
            setCancelReason(val);
          } else {
            setCancelReason("");
          }
        }}
        placeholder={t("Select a reason...")}
        size="large"
        style={{ width: "100%", fontSize: "20px", height:"50px" }}
          optionRender={(option) => (
    <span style={{ fontSize: "20px" }}>{option.label}</span>
  )}
  labelRender={(label) => (
    <span style={{ fontSize: "20px" }}>{label.label}</span>
  )}
        options={cancelReasonOptions}
      />
    </div>

    {/* Show textarea only if "Other" is selected */}
    {cancelReasonType === "Other" && (
      <div className="w-full mb-4">
        <textarea
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
          onKeyDown={(e) => e.stopPropagation()}
          rows={3}
          placeholder={t("Enter reason...")}
          className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-gray-700 bg-gray-50 focus:outline-none text-xl"
          autoFocus
        />
      </div>
    )}

    <div className="flex gap-3 w-full mt-2">
      <button
        onClick={() => { 
          setShowConfirmCancelModal(false); 
          setCancelReason(""); 
          setCancelReasonType("");
        }}
        className="flex-1 py-2.5 rounded-lg border border-gray-200 text-gray-700 font-medium text-lg"
      >
        {t("No")}
      </button>
      <button
        onClick={() => HandleCancelOrder(selectedOrder, cancelReason)}
        disabled={loading || (cancelReasonType == "Other" && cancelReason === "") || cancelReasonType == ''}
        className="flex-1 py-2.5 rounded-lg bg-red-600 hover:bg-red-700 text-white font-medium text-lg disabled:opacity-60"
      >
        {loading ? t("Removing...") : t("Yes, cancel")}
      </button>
    </div>

  </div>
</Modal>

      {isUnpaidModalVisible && (
        <Unpaid_Modal
          onClose={() => setIsUnpaidModalVisible(false)}
          title="Order Details"
          orderDetails={selectedOrderDetails}
          onPaymentSuccess={handlePaymentSuccess}
        ></Unpaid_Modal>
      )}
      <div className="flex">
        <div
          className={`flex-grow transition-all duration-300 ${
            drawerOpen ? "me-[33%]" : "w-full"
          }`}
        >
          <div
            className={`bg-[#EEEEEE] ${
              deviceType == "tablet" ? "mt-12" : "mt-8"
            }`}
          >
            <div className="flex flex-row bg-[#EEEEEE]">
              <div className={`${isRtl ? "ms-20" : "ms-12"} bg-[#EEEEEE]`}>
                <OrderSearchBar
                  setSelectedButton={setSelectedButton}
                  pagination={pagination}
                  setSearchValue={setSearchValue}
                  setType={setSearchType}
                  // ref={searchInputRef}
                />
              </div>
              {showButtons == false ? (
                <>
                  {showOrders && (
                    <>
                      <div
                        style={{
                          marginRight: i18n.language === "ar" ? 20 : 10,
                          marginLeft: i18n.language === "ar" ? 0 : 20,
                        }}
                      >
                        <AllOrderButton
                          // enabled={showOrderTable}
                          enabled={selectedButton === "allOrders"}
                          onClick={handleAllOrderClick}
                          showButtons={false}
                        />
                      </div>
                      <div style={{ marginRight: 10 }}>
                        <RefundedOrderButton
                          enabled={selectedButton === "refundedOrders"}
                          onClick={handleRefundedOrderClick}
                          showButtons={false}
                        />
                      </div>

                      <div style={{ marginRight: 10 }}>
                        <UnpaidOrderButton
                          enabled={selectedButton === "unpaidOrders"}
                          onClick={handleUnpaidOrderClick}
                          showButtons={false}
                        />
                      </div>
                    </>
                  )}
                   <div style={{ marginRight: 10 }}>
                        <CancelledOrderButton
                          enabled={selectedButton === "cancel"}
                          onClick={handleCancelledOrderClick}
                          showButtons={false}
                        />
                      </div>
                  <div
                    className={`${showOrders ? "" : "ms-10"}`}
                    style={{ marginRight: 10 }}
                  >
                    <DraftOrderButton
                      enabled={
                        showDraftOrdersTable && selectedButton === "draftOrders"
                      }
                      onClick={handleDraftClick}
                      showButtons={false}
                    />
                  </div>

                  {/* <OrderFromButton
                    enabled={selectedButton === "orderFrom"}
                    onClick={handleOrderFromClick}
                    showButtons={false}
                  /> */}

                  {showOrders && orderFromOptions.length > 0 && (
                    <div className="relative" style={{ marginRight: 10 }}>
                      <OrderFromButton
                        enabled={selectedOrderFrom !== null}
                        onClick={handleOrderFromClick}
                        showButtons={false}
                      />
                      {showDropdown && (
                        <div className="absolute bg-white border rounded shadow mt-2 z-10">
                          {orderFromOptions.map((method) => (
                            <div
                              key={method.id}
                              onClick={() => handleOrderFromSelect(method)}
                              className={`cursor-pointer px-8 py-2 hover:bg-gray-100 ${
                                selectedOrderFrom?.id === method.id
                                  ? "bg-blue-100 font-semibold"
                                  : ""
                              }`}
                            >
                              {method.name === "self_delivery"
                                ? t("Self Delivery")
                                : t(method.name)}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : null}

              {showButtons ? (
                <>
                  <ReturnOrderButton showButtons={showButtons} />
                </>
              ) : null}
            </div>
          </div>

          {showDraftOrdersTable && draftOrders && draftOrders.length === 0 && (
            <div className="flex flex-col justify-center mr-20 ml-20 mt-8 text-sm bg-white text-left rounded-[15px] overflow-hidden">
              <p className="text-center py-4 text-lg font-semibold text-zinc-800">
                {t("No Draft Orders")}
              </p>
            </div>
          )}
          {showOrders &&
            showOrderTable &&
            filteredData &&
            filteredData.length === 0 && (
              <div className="flex flex-col justify-center mr-20 ml-20 mt-8 text-sm bg-white text-left rounded-[15px] overflow-hidden">
                <p className="text-center py-4 text-lg font-semibold text-zinc-800">
                  {t("No Orders")}
                </p>
              </div>
            )}

          {showOrders && showOrderTable && filteredData && (
            <div className="flex flex-col justify-center mx-20 mt-7 mb-4 pb-2 text-sm bg-white text-left rounded-[15px] overflow-hidden">
              <Table
                columns={columns}
                data={filteredData}
                pagination={pagination}
                isLoadingData={isLoadingData}
                setPagination={setPagination}
                onRowClick={(val) => {
                  navigate(`/orders?orderid=${val?.id}`);
                  handleRowClick(val);
                }}
                selectedRowIndex={selectedOrderIndex}
              />
            </div>
          )}
          {!showOrders &&
            searchValue?.length < 3 &&
            !showDraftOrdersTable &&
            searchData?.length === 0 && (
              <div className="flex flex-col justify-center mr-20 ml-20 mt-8 text-sm bg-white text-left rounded-[15px] overflow-hidden">
                <p className="text-center py-4 text-lg font-semibold text-zinc-800">
                  {t("No Orders")}
                </p>
              </div>
            )}
          {!showDraftOrdersTable &&
            !showOrders &&
            searchValue?.length > 2 &&
            searchType != "" && (
              <div className="flex flex-col justify-center mx-20 mt-7 mb-4 pb-2 text-sm bg-white text-left rounded-[15px] overflow-hidden">
                <Table
                  columns={columns}
                  data={searchData}
                  pagination={pagination}
                  isLoadingData={isLoadingData}
                  setPagination={setPagination}
                  onRowClick={(val) => {
                    navigate(`/orders?orderid=${val?.id}`);
                    handleRowClick(val);
                  }}
                  selectedRowIndex={selectedOrderIndex}
                />
              </div>
            )}
        </div>
      </div>
      {showDraftOrdersTable && draftOrders && draftOrders.length > 0 ? (
        <div className="flex flex-col justify-center mr-20 ml-20 mt-8 text-sm text-left ">
          <DraftOrdersTable
            draftOrders={draftOrders}
            onRowClick={handleDraftOrderClick}
          />
        </div>
      ) : (
        <>
          {drawerOpen && (
            <div
              className={`fixed  ${
                i18n.language === "ar" ? "left-0" : "right-0"
              } h-[calc(140vh-4rem)] w-[29%] bg-white shadow-lg z-50
                transition-transform duration-300
                ${drawerOpen ? "translate-x-0" : "translate-x-full"} ${
                  deviceType == "tablet" ? "top-20" : "top-20"
                }`}
            >
              <div className="flex justify-between px-5 items-center pt-8">
                <h2 className="text-xl font-bold text-blue-900">
                  {t("Receipt No.")} {selectedOrder?.receipt_no}
                </h2>
                <button
                  onClick={() => setDrawerOpen(false)}
                  className="bg-transparent text-gray-500 hover:text-gray-700"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div className="mt-6 px-5 text-base">
                {selectedOrder?.customer_name && (
                  <p>
                    <strong>{t("Customer Name :")}</strong>{" "}
                    {selectedOrder?.customer_name}
                  </p>
                )}
                {/* {selectedOrder?.customer_phone && (
                  <p>
                    <strong>{t("Customer Phone No.:")}</strong>{" "}
                    {selectedOrder?.customer_phone}
                  </p>
                )} */}
                {selectedOrder?.state === "Unpaid" && (
                  <>
                    <p>
                      <strong>{t("Order Value :")}</strong> EGP{" "}
                      {(
                        Number(selectedOrder?.subtotal || 0) +
                        Number(selectedOrder?.total_discount || 0)
                      ).toFixed(2)}
                    </p>
                    {selectedOrder?.total_discount > 0 && (
                      <p>
                        <strong>{t("Total Discount")} :</strong> EGP{" "}
                        {selectedOrder?.total_discount?.toFixed(2)}
                      </p>
                    )}
                    <p>
                      <strong>{t("Delivery Fee :")}</strong> EGP{" "}
                      {selectedOrder?.delivery_fee?.toFixed(2)}
                    </p>
                    {selectedOrder?.return_delivery_fee < 0 && (
                      <p>
                        <strong>{t("Refunded Delivery Fee :")}</strong> EGP{" "}
                        {selectedOrder?.return_delivery_fee?.toFixed(2)}
                      </p>
                    )}
                  </>
                )}

                {selectedOrder?.state === "Paid" && (
                  <>
                    <p>
                      <strong>{t("Order Value :")}</strong> EGP{" "}
                      {(
                        Number(selectedOrder?.order_value || 0) +
                        Number(selectedOrder?.total_discount || 0)
                      ).toFixed(2)}
                    </p>

                    {selectedOrder?.total_discount > 0 && (
                      <p>
                        <strong>{t("Total Discount")} :</strong> EGP{" "}
                        {selectedOrder?.total_discount?.toFixed(2)}
                      </p>
                    )}
                    {selectedOrder?.total_tax_amount > 0 && (
                      <p>
                        <strong>{t("Total Tax")} :</strong> EGP{" "}
                        {selectedOrder?.total_tax_amount?.toFixed(2)}
                      </p>
                    )}
                    {selectedOrder?.delivery_fee > 0 && (
                      <p>
                        <strong>{t("Delivery Fee :")}</strong> EGP{" "}
                        {selectedOrder?.delivery_fee?.toFixed(2)}
                      </p>
                    )}

                    {selectedOrder?.return_delivery_fee < 0 && (
                      <p>
                        <strong>{t("Refunded Delivery Fee :")}</strong> EGP{" "}
                        {selectedOrder?.return_delivery_fee?.toFixed(2)}
                      </p>
                    )}
                  </>
                )}
                <p>
                  <strong>{t("Total Amount :")}</strong> EGP{" "}
                  {(selectedOrder?.subtotal < 0
                    ? selectedOrder?.subtotal -
                      Math.abs(selectedOrder?.return_delivery_fee)
                    : selectedOrder?.subtotal +
                      selectedOrder?.return_delivery_fee +
                      selectedOrder?.delivery_fee
                  ).toFixed(2)}
                </p>
                <div className="flex flex-row justify-between">
                  <div>
                    <p>
                      <strong>{t("Number of Items :")}</strong>{" "}
                      {selectedOrder?.items}
                    </p>
                    <p>
                      <strong>{t("Payment Type :")}</strong>{" "}
                      {t(selectedOrder?.payment)}
                    </p>
                    {selectedOrder?.salesman &&
                      selectedOrder?.salesman != "" && (
                        <p>
                          <strong>{t("Salesman Name:")}</strong>{" "}
                          {selectedOrder?.salesman}
                        </p>
                      )}

                    {selectedOrder?.state === "Unpaid" &&
                    !areAllProductsRefundedOrNegative() ? (
                      <p>
                        <strong>{t("Payment Status :")}</strong> {t("Unpaid")}
                      </p>
                    ) : (
                      !areAllProductsRefundedOrNegative() &&
                      selectedOrder.state === "Paid" && (
                        <p>
                          <strong>{t("Payment Status :")}</strong> {t("Paid")}
                        </p>
                      )
                    )}
                    {selectedOrder?.state === "Cancelled" && (
                        <p>
                          <strong>{t("Cancel Reason:")}</strong>{" "}
                          {selectedOrder?.cancel_reason}
                        </p>
                      )}
                  </div>

                  {/* {!areAllProductsRefundedOrNegative() && selectedOrder.state === "paid" && (
                    <RefundOrderButton onClick={handleReturnClick} />
                  )} */}
                </div>
                <div className="flex justify-between mt-3">
                  {selectedOrder?.state === "Unpaid" ? (
                    <button
                      // onClick={() => setIsUnpaidModalVisible(true)}
                      onClick={() => {
                        setShowConfirmCancelModal(true);
                        setDrawerOpen(false);
                      }}
                      className="flex justify-center items-center px-4 py-4  font-semibold hover:font-semibold text-white bg-[#F42020] border border-solid border-stone-300 whitespace-nowrap rounded-lg cursor-pointer"
                    >
                      <div className="justify-center items-center">
                        {t("Cancel Order")}
                      </div>
                    </button>
                  ) : 
                  <div></div>}
                  {selectedOrder?.state === "Unpaid" &&
                  !areAllProductsRefundedOrNegative() ? (
                    <button
                      // onClick={() => setIsUnpaidModalVisible(true)}
                      onClick={() => {
                        setSelectedOrderDetails(selectedOrder); // Set the selected order details
                        setIsUnpaidModalVisible(true);
                      }}
                      className="flex justify-center items-center px-4 py-4 font-semibold hover:font-semibold text-white bg-[#7EC242] border border-solid border-stone-300 whitespace-nowrap rounded-lg cursor-pointer"
                    >
                      <div className="justify-center items-center">
                        {t("Collect Payment")}
                      </div>
                    </button>
                  ) : (
                    !areAllProductsRefundedOrNegative() &&
                    selectedOrder.state === "Paid" && (
                      <RefundOrderButton onClick={ReturnButtonClick} />
                    )
                  )}
                </div>
                {!areAllProductsRefundedOrNegative() &&
                  selectedOrder?.state != "Unpaid" && (
                    <div className="flex items-center mb-2 mt-5">
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={selectAll}
                        className="w-5 h-5 accent-[#1B4597]"
                      />
                      <label className="ms-2">{t("Select All")}</label>
                    </div>
                  )}
              </div>
              {loading ? (
                <div className="px-5">
                  <OrderSkeleton />
                </div>
              ) : (
                // h-[62%]----- previously
                <div className="mt-6 px-5 overflow-y-auto h-[58%] custom-scrollbar">
                  {orderLines?.map((product, index) => {
                    const refundQtyForProduct =
                      refundItems?.find(
                        (prod) => prod.product_id === product.product_id,
                      )?.qty || 0;
                    return (
                      <ProductList
                        key={index}
                        selectedOrder={selectedOrder}
                        refundQtyForProduct={refundQtyForProduct}
                        selectAllClick={() =>
                          handleSelectAll({ target: { checked: !selectAll } })
                        }
                        product={{
                          id: product.product_id,
                          name: product.name,
                          image: product.image_url,
                          size:
                            product.variants[0]?.Size ||
                            product.variants[0]?.Type ||
                            "",
                          pack_qty: product.pack_qty,
                          quantity: product.qty,
                          rate: product.price,
                          currency: product.currency,
                          uom: product.uom,
                          available_refund_qty: product?.available_refund_qty,
                          pack_id: product?.package_id,
                          discount_amount:
                            product?.discount_amount /
                            (product.qty >= 0 ? product.qty : -product.qty),
                          discounted_value: product?.discounted_value,
                          tax_id: product?.tax_id,
                          tax_amount: product?.tax_amount,
                          tax_rate_percent: product?.tax_rate_percent,
                          is_tax_price_inclusive:
                            product?.is_tax_price_inclusive,
                          hamper_id: product?.hamper_id
                            ? product?.hamper_id
                            : null,
                          uom: product?.uom,
                          is_selling_gram: product?.is_selling_gram,
                          payment_method_id: selectedOrder?.payment_method_id,
                          bank_id: selectedOrder?.bank_id,
                        }}
                        isChecked={
                          selectedProducts[product.product_id] || false
                        }
                        onCheckboxChange={handleProductCheckboxChange(
                          product.product_id,
                        )}
                        updateRefundItems={updateRefundItems}
                        isProductSelect={index === selectedProductIndex}
                      />
                    );
                  })}
                  <div className="flex flex-row w-full absolute bottom-2 end-2 justify-center items-center mt-10 font-semibold text-lg">
                    {showResendButton && orderLines[0]?.uniq_code_pos && (
                      <ResendButton onClick={handleResetClick} />
                    )}

                    <InvoiceButton
                      width={selectedOrder?.customer_phone ? "half" : "full"}
                      onClick={handleInvoiceClick}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
}

export default Order_Table;
